import request from '@/utils/request'

export function epms9065(param) {
  let data = param
  return request({
    url: `/deliveryreport/epms9065/epms9065`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

